<br-header-action
    [hasLogin]="hasLogin()"
    [labelLogin]="labelLogin()"
    [imageAvatarLogin]="imageAvatarLogin()"
    [titleFunctions]="iconLinksTitle()"
    [listFunctions]="iconLinks()"
    [titleLinks]="linksTitle()"
    [listLinks]="links()"
>
</br-header-action>
